import { createFileRoute } from "@tanstack/react-router";
import { CollectionsContainer } from "@/features/collections";

export const Route = createFileRoute("/$store/_layout/collections")({
	component: CollectionsPage,
});

function CollectionsPage() {
	return <CollectionsContainer />;
}
